import Vue from "vue";
import msal from "vue-msal";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSignOutAlt,
  faWindowClose,
  faExternalLinkAlt,
  faChevronDown,
  faEdit,
  faSave,
  faFileDownload,
  faCopy,
  faDesktop,
  faTerminal,
  faPlug,
  faPlusCircle
} from "@fortawesome/free-solid-svg-icons";
import VueClipboard from "vue-clipboard2";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  Button,
  Layout,
  Menu,
  Input,
  Form,
  Row,
  Col,
  Collapse,
  Icon,
  Dropdown,
  notification,
  Progress,
  Avatar,
  Checkbox,
  Switch,
  message,
  Tooltip,
  InputNumber,
  Divider,
  Spin,
  List
} from "ant-design-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "ant-design-vue/dist/antd.css";
import { msalConfig, msalEnv } from "./config/authConfig";
import msalTestStub from "./config/msalTestStub";

library.add(faSignOutAlt);
library.add(faWindowClose);
library.add(faExternalLinkAlt);
library.add(faChevronDown);
library.add(faEdit);
library.add(faSave);
library.add(faFileDownload);
library.add(faCopy);
library.add(faDesktop);
library.add(faTerminal);
library.add(faPlug);
library.add(faPlusCircle);

Vue.component("font-awesome-icon", FontAwesomeIcon);

// Workaround to stub MSAL for tests
if ("test" === msalEnv.toLowerCase()) {
  console.log("MSAL is stubbed....");
  //cypress - test environment
  Vue.use(msalTestStub);
} else {
  // productive / dev environment
  Vue.use(msal, msalConfig);
}

Vue.prototype.$notification = notification;

Vue.use(Button);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Input);
Vue.use(Form);
Vue.use(Row);
Vue.use(Col);
Vue.use(Icon);
Vue.use(Collapse);
Vue.use(Dropdown);
Vue.use(notification);
Vue.use(Progress);
Vue.use(Avatar);
Vue.use(Checkbox);
Vue.use(Switch);
Vue.use(message);
Vue.use(Tooltip);
Vue.use(VueClipboard);
Vue.use(InputNumber);
Vue.use(Divider);
Vue.use(Spin);
Vue.use(List);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
